<template>
  <b-row>
    <b-col md="12">
      <p style="text-align: center; font-size: 14px"><b>Desenvolvido por Diego Mauricio da Cruz, Copyright 2021 - Todos os direitos reservados.</b></p>
    </b-col>
  </b-row>
</template>

<script>
export default {
 
}
</script>

<style>

</style>